interface MessageBubbleProps {
  body: string;
  createdAt: string;
  isSent: boolean;
  senderName?: string;
}

export function MessageBubble({ body, createdAt, isSent, senderName }: MessageBubbleProps) {
  const time = new Date(createdAt).toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });

  return (
    <div className={`flex ${isSent ? "justify-end" : "justify-start"}`} role="listitem">
      <div
        aria-label={`${isSent ? "You" : senderName ?? "Other"} at ${time}`}
        className={`max-w-[75%] rounded-2xl px-4 py-2 ${
          isSent
            ? "bg-gray-900 text-white"
            : "bg-gray-100 text-gray-900"
        }`}
      >
        {!isSent && senderName && (
          <p className="mb-0.5 text-xs font-medium text-gray-500">{senderName}</p>
        )}
        <p className="whitespace-pre-wrap break-words text-sm">{body}</p>
        <p
          className={`mt-1 text-[10px] ${
            isSent ? "text-gray-400" : "text-gray-500"
          }`}
        >
          {time}
        </p>
      </div>
    </div>
  );
}
